export default __webpack_public_path__ + "static/personalfundraise-4-4e07eff2ed5137105760462eae254a9d.png";